import { createFileRoute, useParams } from '@tanstack/react-router';

import { ClientDetailScreen } from '@/features/clients/components/shared/ClientDetailScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/clients/$clientId')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: PlatformClientDetailRoute,
  staticData: { crumb: 'Client' },
});

function PlatformClientDetailRoute() {
  const { clientId } = useParams({ from: '/_staff/admin/platform/clients/$clientId' });
  return <ClientDetailScreen clientId={clientId} surface="platform" />;
}
